// src/data/legalContent.js
// Contenido legal de SenDViGo, separado de la UI para poder actualizarlo
// sin tocar la lógica de ningún componente, y para poder reutilizarlo en
// más de un sitio (perfil, registro, etc.) si hace falta en el futuro.

export const PRIVACIDAD = [
  {
    titulo: 'Responsable',
    texto: 'SenDViGo · soporte@sendvigo.com · España',
  },
  {
    titulo: 'Datos que recogemos',
    texto: 'Nombre, dirección de email, foto de perfil (opcional) y descripción personal (opcional). Solo los datos necesarios para el funcionamiento de la plataforma.',
  },
  {
    titulo: 'Finalidad',
    texto: 'Gestionar tu cuenta, permitir la comunicación entre usuarios para coordinar envíos, y enviarte notificaciones relacionadas con la actividad de tu cuenta.',
  },
  {
    titulo: 'Proveedores externos',
    texto: 'Las imágenes se almacenan en Cloudinary (EE.UU.). Los emails se envían a través de Resend. Las notificaciones push se gestionan mediante Firebase (Google). Cuando aplique, los SMS se envían mediante Twilio. Estos proveedores actúan como encargados del tratamiento bajo contrato, y las transferencias fuera del Espacio Económico Europeo se realizan bajo las garantías adecuadas (Cláusulas Contractuales Tipo de la Comisión Europea u otro mecanismo válido conforme al RGPD).',
  },
  {
    titulo: 'Cookies y almacenamiento local',
    texto: 'La app utiliza almacenamiento local del navegador/dispositivo (localStorage) para recordar preferencias técnicas, como chats ocultados o la última vez que visitaste una conversación. Estos datos son estrictamente necesarios para el funcionamiento de la app, no se comparten con terceros, y se eliminan al borrar los datos de la app o desinstalarla.',
  },
  {
    titulo: 'Base legal',
    texto: 'Consentimiento del usuario al registrarse (Art. 6.1.a RGPD). Puedes retirar tu consentimiento en cualquier momento eliminando tu cuenta.',
  },
  {
    titulo: 'Conservación de datos',
    texto: 'Tus datos se conservan mientras mantengas tu cuenta activa. Al eliminar tu cuenta, todos tus datos personales son eliminados de forma permanente.',
  },
  {
    titulo: 'Tus derechos',
    texto: 'Tienes derecho a acceder, rectificar, suprimir, limitar u oponerte al tratamiento de tus datos. Puedes ejercerlos escribiendo a soporte@sendvigo.com o eliminando tu cuenta desde Ajustes. También puedes reclamar ante la Agencia Española de Protección de Datos (aepd.es).',
  },
  {
    titulo: 'Cesión de datos',
    texto: 'No cedemos tus datos a terceros ni los utilizamos con fines publicitarios. SenDViGo no vende datos de usuarios.',
  },
];

export const TERMINOS = [
  {
    titulo: '¿Qué es SenDViGo?',
    texto: 'SenDViGo es una plataforma digital que conecta personas particulares que necesitan enviar objetos con otras personas que ya realizan un viaje en la misma dirección. No somos una empresa de mensajería ni de transporte profesional.',
  },
  {
    titulo: 'Edad mínima',
    texto: 'Es necesario tener 18 años o más para usar SenDViGo. Al registrarte confirmas que cumples este requisito.',
  },
  {
    titulo: 'Contribuciones económicas',
    texto: 'SenDViGo no procesa pagos ni actúa como intermediario financiero. Las contribuciones mostradas son orientativas y constituyen acuerdos privados y voluntarios entre los usuarios. SenDViGo no es responsable de dichos acuerdos.',
  },
  {
    titulo: 'Responsabilidad de los usuarios',
    texto: 'Cada usuario es responsable de sus acciones, de los objetos que envía o transporta, y del cumplimiento de la legislación vigente. SenDViGo no garantiza la identidad de los usuarios ni la calidad de los servicios prestados entre ellos.',
  },
  {
    titulo: 'Contenido prohibido',
    texto: 'Queda estrictamente prohibido usar SenDViGo para transportar: objetos ilegales, peligrosos o sustancias controladas; armas de cualquier tipo; dinero en efectivo, joyas u objetos de alto valor; animales vivos; productos perecederos o que requieran cadena de frío; alcohol o tabaco cuando el destinatario sea menor de edad; medicamentos sin la documentación legal correspondiente; productos falsificados o de origen ilícito; y, en general, cualquier bien cuyo transporte infrinja la legislación española, europea o del país de destino. El incumplimiento puede conllevar la suspensión inmediata de la cuenta y, si procede, la puesta en conocimiento de las autoridades competentes.',
  },
  {
    titulo: 'Verificación de identidad',
    texto: 'SenDViGo ofrece herramientas de verificación entre usuarios basadas en la confirmación mutua de participantes en un mismo envío, pero no realiza una verificación oficial de identidad (DNI, pasaporte u otro documento) de ninguno de sus usuarios. La plataforma no garantiza que la identidad, edad o intenciones declaradas por un usuario sean veraces. Se recomienda a los usuarios actuar con prudencia razonable al coordinar encuentros con otras personas.',
  },
  {
    titulo: 'Indemnización',
    texto: 'El usuario se compromete a indemnizar y mantener indemne a SenDViGo frente a cualquier reclamación, daño, pérdida o gasto (incluidos honorarios legales razonables) derivado del incumplimiento de estos términos, del contenido que transporte o del uso indebido de la plataforma por su parte.',
  },
  {
    titulo: 'Limitación de responsabilidad',
    texto: 'SenDViGo actúa únicamente como intermediario tecnológico que facilita el contacto entre usuarios. No presta servicios de transporte, mensajería, seguro ni custodia de bienes, y no se hace responsable de pérdidas, daños, robos, retrasos o cualquier incidencia ocurrida durante los envíos acordados entre usuarios, ni de los acuerdos económicos alcanzados entre ellos. SenDViGo no ofrece ningún seguro sobre los objetos transportados; cualquier cobertura de este tipo es responsabilidad exclusiva de los usuarios.',
  },
  {
    titulo: 'Reportes y suspensión de cuentas',
    texto: 'Los usuarios pueden reportar comportamientos o contenidos inapropiados desde la propia app. SenDViGo se reserva el derecho de investigar cualquier reporte y de suspender o eliminar, de forma temporal o permanente, las cuentas que incumplan estos términos, sin perjuicio de otras acciones legales que puedan corresponder.',
  },
  {
    titulo: 'Cancelación y eliminación',
    texto: 'Puedes eliminar tu cuenta en cualquier momento desde Ajustes → Eliminar cuenta. SenDViGo se reserva el derecho de suspender cuentas que incumplan estos términos.',
  },
  {
    titulo: 'Modificaciones',
    texto: 'SenDViGo puede modificar estos términos en cualquier momento. Los cambios significativos se comunicarán a los usuarios con antelación razonable.',
  },
  {
    titulo: 'Legislación aplicable y resolución de conflictos',
    texto: 'Estos términos se rigen por la legislación española. Para cualquier disputa, las partes se someten a los juzgados y tribunales de España, sin perjuicio de los derechos del consumidor reconocidos por la normativa europea. Si eres consumidor residente en la Unión Europea, también puedes acceder a la plataforma europea de resolución de litigios en línea: ec.europa.eu/consumers/odr.',
  },
];